<div class="tesla-document-content">
  @if (data()?.breadcrumb) {
    <div class="mb-4 text-sm text-gray-600">
      {{ data()?.breadcrumb }}
    </div>
  }

  @if (htmlData()) {
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
    <div appImageZoom [innerHTML]="htmlData()" (click)="handleClick($event)" tabindex="0" role="region"></div>
  }

  @if (!htmlData()) {
    <p class="mt-8 text-center text-sm text-gray-500">{{ 'global.noOEDataFound' | transloco }}</p>
  }
</div>
